var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@lucidlink/uicore';
export const FullscreenLayout = ({ children }) => {
    return (_jsx(Box, { isFullHeight: true, isFullWidth: true, kind: "level1", padding: "s", children: children }));
};
_react_refresh_temp_1 = FullscreenLayout;
$RefreshReg$(_react_refresh_temp_1, "FullscreenLayout");
